import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";

import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

import Layout from "./components/Layout/Layout";
import Dashboard from "views/dashboard";
import NotFound from "views/NotFound";
import Login from "views/login";
import Logout from "views/Logout";
import { getAllSettings, getCurrentUser } from "store/actions";
import Loader from "./components/shared/Loader";

import Settings from "views/Settings";

import Intro from "views/home/intro";
import About from "views/home/about";
import Features from "views/home/features";
import DownloadApp from "views/home/downloadApp";
import Terms from "views/home/terms";

import Brief from "views/about/brief";
// import Features from "views/about/features";
import WhyUs from "views/about/whyUs";

import Projects from "views/projects";
import EditProject from "views/projects/EditProject";
import AddProject from "views/projects/AddProject";
import ProjectsHeading from "views/projects/Heading";

import Systems from "views/systems";
import EditSystem from "views/systems/EditSystem";
import AddSystem from "views/systems/AddSystem";
import SystemsHeading from "views/systems/Heading";

import Partners from "views/partners";
import EditPartner from "views/partners/EditPartner";
import AddPartner from "views/partners/AddPartner";
import PartnersHeading from "views/partners/Heading";

import Subscribers from "views/subscribers";
import ContactUs from "views/ContactUs";

import Socials from "views/socials";
import AddSocial from "views/socials/AddSocial";
import EditSocial from "views/socials/EditSocial";
import ShowContact from "views/ContactUs/ShowContact";
import EditCategory from "views/categories/EditCategory";
import AddCategory from "views/categories/AddCategory";
import Categories from "views/categories";
import CategoriesHeading from "views/categories/Heading";
import AddCountry from "views/countries/AddCountry";
import EditCountry from "views/countries/EditCountry";
import Countries from "views/countries/Index";
import Personnel from "views/personnel";
import AddPersonnel from "views/personnel/Add";
import EditPersonnel from "views/personnel/Edit";
import Requests from "views/requests";
import ShowRequest from "views/requests/ShowContact";
import SocialLinks from "views/socialLinks";
import AddSocialLink from "views/socialLinks/AddSocial";
import EditSocialLink from "views/socialLinks/EditSocial";
import SeoData from "views/SeoData";

import AddBlog from "views/blogs/AddBlog";
import ShowBlog from "views/blogs/ShowBlog";
// import AddBlogCategory from "views/blogsCategories/AddBlogCategory";
// import EditBlogCategory from "views/blogsCategories/EditBlogCategory";
import Blogs from "views/blogs/Index";
// import HomeBlogs from "views/home/blogs";
// import BlogCategories from "views/blogsCategories/Index";
import EditBlog from "views/blogs/EditBlog";
import BlogsSeo from "views/blogs/seo";

import Links from "views/links/index.js";
import ShowLink from "views/links/EditLink";
import AddLink from "views/links/AddLink";
const App = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  //selectors
  const { isLoggedIn } = useSelector((state) => state?.authentication);
  const { settings } = useSelector((state) => state.settings);
  const logo = settings?.appLogo;

  useEffect(() => {
    dispatch(getAllSettings());
  }, [dispatch]);

  useEffect(() => {
    if (token) dispatch(getCurrentUser());
  }, [token, dispatch]);

  const RenderApp = () => {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout logo={logo} />}>
              <Route
                path="/"
                element={
                  <AuthRoute>
                    <Dashboard />
                  </AuthRoute>
                }
              />

              {/* home  */}
              <Route
                path="/home/intro"
                element={
                  <AuthRoute>
                    <Intro />
                  </AuthRoute>
                }
              />

              <Route
                path="/home/about"
                element={
                  <AuthRoute>
                    <About />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/features"
                element={
                  <AuthRoute>
                    <Features />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/download-app"
                element={
                  <AuthRoute>
                    <DownloadApp />
                  </AuthRoute>
                }
              />
              <Route
                path="/home/terms-conditions"
                element={
                  <AuthRoute>
                    <Terms />
                  </AuthRoute>
                }
              />

              {/* about  */}
              {/* <Route
                path="/about/brief"
                element={
                  <AuthRoute>
                    <Brief />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                                path="home/blogs"
                                element={
                                    <AuthRoute>
                                        <HomeBlogs />
                                    </AuthRoute>
                                }
                            /> */}
              {/* <Route
                path="/blogs"
                element={
                  <AuthRoute>
                    <Blogs />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/seo"
                element={
                  <AuthRoute>
                    <BlogsSeo />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/addblog"
                element={
                  <AuthRoute>
                    <AddBlog />
                  </AuthRoute>
                }
              />
              <Route
                path="/blogs/:id"
                element={
                  <AuthRoute>
                    <EditBlog />
                  </AuthRoute>
                }
              />

              <Route
                path="/blogs/show/:id"
                element={
                  <AuthRoute>
                    <ShowBlog />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                              path="/blogs/categories"
                              element={
                                <AuthRoute>
                                  <BlogCategories />
                                </AuthRoute>
                              }
                            /> */}

              {/* <Route
                                path="/blogs/categories/addcategory"
                                element={
                                    <AuthRoute>
                                        <AddBlogCategory />
                                    </AuthRoute>
                                }
                            /> */}
              {/* <Route
                                path="/blogs/categories/:id" 
                                element={
                                    <AuthRoute>
                                        <EditBlogCategory />
                                    </AuthRoute>
                                }
                            /> */}

              {/* <Route
                path="/about/features"
                element={
                  <AuthRoute>
                    <Features />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/about/why-us"
                element={
                  <AuthRoute>
                    <WhyUs />
                  </AuthRoute>
                }
              /> */}

              {/* personnels */}
              {/* <Route
                path="/personnels"
                element={
                  <AuthRoute>
                    <Personnel />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/personnels/add"
                element={
                  <AuthRoute>
                    <AddPersonnel />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/personnels/:id"
                element={
                  <AuthRoute>
                    <EditPersonnel />
                  </AuthRoute>
                }
              /> */}

              {/* requests */}
              {/* <Route
                path="/requests"
                element={
                  <AuthRoute>
                    <Requests />
                  </AuthRoute>
                }
              /> */}

              <Route
                path="/requests/show/:id"
                element={
                  <AuthRoute>
                    <ShowRequest />
                  </AuthRoute>
                }
              />

              {/* projects */}
              {/* <Route
                path="/categories"
                element={
                  <AuthRoute>
                    <Categories />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/categories/add"
                element={
                  <AuthRoute>
                    <AddCategory />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/categories/heading"
                element={
                  <AuthRoute>
                    <CategoriesHeading />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/categories/:id"
                element={
                  <AuthRoute>
                    <EditCategory />
                  </AuthRoute>
                }
              /> */}

              {/* countries */}

              {/* <Route
                path="/countries"
                element={
                  <AuthRoute>
                    <Countries />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/countries/addcountry"
                element={
                  <AuthRoute>
                    <AddCountry />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/countries/:id"
                element={
                  <AuthRoute>
                    <EditCountry />
                  </AuthRoute>
                }
              /> */}

              {/* projects */}
              {/* <Route
                path="/projects"
                element={
                  <AuthRoute>
                    <Projects />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/projects/addProject"
                element={
                  <AuthRoute>
                    <AddProject />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/projects/heading"
                element={
                  <AuthRoute>
                    <ProjectsHeading />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/projects/:id"
                element={
                  <AuthRoute>
                    <EditProject />
                  </AuthRoute>
                }
              /> */}

              {/* systems */}
              {/* <Route
                path="/systems"
                element={
                  <AuthRoute>
                    <Systems />
                  </AuthRoute>
                }
              /> */}
              {/* 
              <Route
                path="/systems/AddSystem"
                element={
                  <AuthRoute>
                    <AddSystem />
                  </AuthRoute>
                }
              /> */}
              {/* <Route
                path="/systems/heading"
                element={
                  <AuthRoute>
                    <SystemsHeading />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/systems/:id"
                element={
                  <AuthRoute>
                    <EditSystem />
                  </AuthRoute>
                }
              /> */}

              {/* partners */}
              {/* <Route
                path="/partners"
                element={
                  <AuthRoute>
                    <Partners />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/partners/addPartner"
                element={
                  <AuthRoute>
                    <AddPartner />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/partners/heading"
                element={
                  <AuthRoute>
                    <PartnersHeading />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/partners/:id"
                element={
                  <AuthRoute>
                    <EditPartner />
                  </AuthRoute>
                }
              /> */}

              {/* subscribers */}
              {/* <Route
                path="/subscribers"
                element={
                  <AuthRoute>
                    <Subscribers />
                  </AuthRoute>
                }
              /> */}

              <Route
                path="/contactUs"
                element={
                  <AuthRoute>
                    <ContactUs />
                  </AuthRoute>
                }
              />

              <Route
                path="/contactUs/show/:id"
                element={
                  <AuthRoute>
                    <ShowContact />
                  </AuthRoute>
                }
              />

              {/* socials */}
              <Route
                path="/socialLinks"
                element={
                  <AuthRoute>
                    <SocialLinks />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialLinks/addSocial"
                element={
                  <AuthRoute>
                    <AddSocialLink />
                  </AuthRoute>
                }
              />

              <Route
                path="/socialLinks/:id"
                element={
                  <AuthRoute>
                    <EditSocialLink />
                  </AuthRoute>
                }
              />
              {/* <Route
                path="/pages/seo-data"
                element={
                  <AuthRoute>
                    <SeoData />
                  </AuthRoute>
                }
              /> */}
              {/* inquiries */}
              {/* <Route
                path="/inquiries"
                element={
                  <AuthRoute>
                    <Socials />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/inquiries/addSocial"
                element={
                  <AuthRoute>
                    <AddSocial />
                  </AuthRoute>
                }
              /> */}

              {/* <Route
                path="/inquiries/:id"
                element={
                  <AuthRoute>
                    <EditSocial />
                  </AuthRoute>
                }
              /> */}
              <Route
                path="/links"
                element={
                  <AuthRoute>
                    <Links />
                  </AuthRoute>
                }
              />

              <Route
                path="/links/show/:slug"
                element={
                  <AuthRoute>
                    <ShowLink />
                  </AuthRoute>
                }
              />
              <Route
                path="/links/addLink"
                element={
                  <AuthRoute>
                    <AddLink />
                  </AuthRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <AuthRoute>
                    <Settings />
                  </AuthRoute>
                }
              />

              <Route
                path="*"
                element={
                  <AuthRoute>
                    <NotFound />
                  </AuthRoute>
                }
              />
            </Route>

            {/*Auth Routes */}
            <Route
              path="/logout"
              element={
                <AuthRoute>
                  <Logout />
                </AuthRoute>
              }
            />
            <Route
              path="/login"
              element={
                <GuestRoute>
                  <Login logo={logo} />
                </GuestRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </Suspense>
    );
  };

  if (!token) return RenderApp();
  if (isLoggedIn !== null) return RenderApp();
  return <Loader />;
};

export default App;
